













import {Component, Vue} from 'vue-property-decorator';
import {mapActions, mapState} from 'vuex';
import PlanEditModel, {Tab, WarehouseDescription} from '@/models/PlanEditModel';

@Component({
    computed: {
        ...mapState('planEdit', ['warehousePlywoodDescriptions', 'planEdit']),
    },
    methods: {
        ...mapActions('planEdit', ['getWarehousePlywoodDescriptions']),
    },
})
export default class PlanEditWarehousePlywood extends Vue {
    private loading = false;
    private tabIndex = -1;
    private inactive = false;
    public getWarehousePlywoodDescriptions!: Function;
    public warehousePlywoodDescriptions!: WarehouseDescription[] | null;
    public planEdit!: PlanEditModel | null;

    get tabs() {
        return this.warehousePlywoodDescriptions
            ? [
                  {
                      text: this.$t('Catalogues.Warehouses.Warehouse.AllWarehouses'),
                      key: 'common',
                      id: null,
                      path: `/planedit/${this.planEdit?.Id}/warehouseplywood`,
                  },
                  ...this.warehousePlywoodDescriptions?.map(item => ({
                      text: item.Description,
                      key: String(item.Id),
                      id: item.Id,
                      path: `/planedit/${this.planEdit?.Id}/warehouseplywood/${item.Id}`,
                  })),
              ]
            : null;
    }

    get idPlan() {
        return this.planEdit?.Id;
    }

    async activated() {
        this.inactive = false;
        if (!this.tabs) {
            this.loading = true;
            try {
                await this.getWarehousePlywoodDescriptions();
            } finally {
                this.loading = false;
            }
        }
        if (this.tabs === null) return;
        if (this.tabIndex === -1) this.getActualTab();
        else this.$router.replace(this.tabs[this.tabIndex].path).catch(() => {});
    }
    deactivated() {
        this.inactive = true;
    }

    onTabClick(tab: Tab, index: number) {
        if (this.tabIndex === index) return;
        this.tabIndex = index;
        this.$router.replace(tab.path).catch(() => {});
    }
    getActualTab() {
        if (this.tabs === null) return;
        let index = this.tabs.findIndex(item => this.$route.params.idWarehousePlywood === String(item.id));
        if (index === -1) {
            this.tabIndex = 0;
            this.$router.replace(this.tabs[this.tabIndex].path).catch(() => {});
        } else {
            this.tabIndex = index;
        }
    }
}
